"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepEvents = exports.StoryTeller = exports.INITIAL_TIMELINE = exports.INITIAL_STEP = exports.StoryEvents = void 0;
const sortKeys_1 = require("./utils/sortKeys");
const copy_1 = require("./utils/copy");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const migration_1 = require("./migration");
const storyConfig = {
    /** @deprecated maxChars to be removed with migration14 */
    maxChars: 4,
    slotsLayout: {
        cs1: {
            x: -225.85651537335286,
            y: 379.21156661786245,
            dir: 1,
        },
        cs2: {
            x: 11.332357247437812,
            y: 384.1874084919473,
            dir: 1,
        },
        cs3: {
            x: 240.61493411420201,
            y: 376.2811127379209,
            dir: -1,
        },
    },
    maxChoiceOptions: 3,
    firstMigrationVersion: 1,
};
const getSlotDefaultConfig = (slotId) => {
    const layoutConfig = storyConfig.slotsLayout[slotId];
    if (!layoutConfig) {
        throw new Error(`Error (getSlotDefaultConfig): Cannot find config for slotId '${slotId}'`);
    }
    return {
        id: slotId,
        disabledOnStart: false,
        layout: {
            x: layoutConfig.x,
            y: layoutConfig.y,
            dir: layoutConfig.dir,
            scale: 0.8,
            zIndex: 0,
            layer: 0,
        },
        charMetadata: 'https://cms.characters.alpha.pnk.one/defaultcast/0xED5AF388653567Af2F388E6224dC7C4b3241C544/6352/metadata.json',
    };
};
const getDiff = (prevVal, newVal) => {
    if (!prevVal || !newVal) {
        // If they are equally undefined, no diff
        if (!prevVal && !newVal) {
            return {
                same: prevVal,
                diff: undefined,
            };
        }
        return {
            same: undefined,
            diff: {
                old: prevVal,
                new: newVal,
            },
        };
    }
    return [...new Set([...Object.keys(prevVal), ...Object.keys(newVal)])].reduce((res, cur) => {
        const val1 = prevVal[cur];
        const val2 = newVal[cur];
        const isSame = (0, lodash_isequal_1.default)(val1, val2);
        if (isSame) {
            return {
                ...res,
                same: {
                    ...res.same,
                    [cur]: val1,
                },
            };
        }
        return {
            ...res,
            diff: {
                ...res.diff,
                [cur]: {
                    old: val1,
                    new: val2,
                },
            },
        };
    }, {});
};
/**
 * Steps are linear
 * Timelines are not, once a timeline is removed, we do not reindex the obj keys
 *
 * Every object GET must be wrapped in `copy` so it's readonly
 */
var StoryEvents;
(function (StoryEvents) {
    StoryEvents["SLOTS_UPDATE"] = "slots";
    StoryEvents["FILTER_UPDATE"] = "filter";
    StoryEvents["TIMELINE_NAVIGATION"] = "timeline navigation";
    StoryEvents["STEP_NAVIGATION"] = "step navigation";
})(StoryEvents = exports.StoryEvents || (exports.StoryEvents = {}));
exports.INITIAL_STEP = 's1';
exports.INITIAL_TIMELINE = 't1';
class StoryTeller {
    constructor(props) {
        this.getDefaultStory = () => {
            return {
                filterPreset: 'none',
                charSlots: {},
                metadata: {
                    timestamp: Date.now(),
                    version: migration_1.lastMigrationVersion,
                    saveCount: 0,
                    editedBy: 'migrator',
                    templateIndex: undefined,
                    revealSchedule: undefined,
                },
                rootTimelineId: exports.INITIAL_TIMELINE,
                timelines: {
                    [exports.INITIAL_TIMELINE]: {
                        root: exports.INITIAL_TIMELINE,
                        firstStep: exports.INITIAL_STEP,
                        lastStep: exports.INITIAL_STEP,
                        steps: {},
                        toTimeline: undefined,
                        mergeTimeline: undefined,
                    },
                },
                revealedTimelineId: undefined,
                choicesMade: {},
            };
        };
        this.toString = () => JSON.stringify(this.story, null, 2);
        this.story = this.getDefaultStory();
        this._timelineId = (props === null || props === void 0 ? void 0 : props.timelineId) || exports.INITIAL_TIMELINE;
        this._stepId = (props === null || props === void 0 ? void 0 : props.stepId) || exports.INITIAL_STEP;
        this._steps = {};
        this.eventHandlers = {};
        this._selectedChoice = undefined;
    }
    get isRootTimeline() {
        return this._timelineId === exports.INITIAL_TIMELINE;
    }
    get isChoiceTimeline() {
        return Boolean(this.selectedChoice);
    }
    get isMergeTimeline() {
        return Object.values(this.story.timelines).some((timeline) => timeline.mergeTimeline === this.timelineId);
    }
    get isFirstStep() {
        return this._stepId === exports.INITIAL_STEP;
    }
    get isLastStep() {
        return this._stepId === this.lastStepId;
    }
    get timelineId() {
        return this._timelineId;
    }
    set stepId(id) {
        this._stepId = id;
    }
    get stepId() {
        return this._stepId;
    }
    get slotIds() {
        return (0, sortKeys_1.sortKeys)(Object.keys(this.story.charSlots));
    }
    get stepsCount() {
        return this.stepIds.length;
    }
    get linearStepIndex() {
        return this.stepIds.indexOf(this.stepId);
    }
    get metadata() {
        // return a copy so if the user changes the values from within metadata, doesnt affect the class instance
        return (0, copy_1.copyStrict)(this.story.metadata);
    }
    get lastStep() {
        return this.timeline.lastStep;
    }
    // @TODO: Ideally dont expose this
    get slots() {
        return (0, copy_1.copyStrict)(this.story.charSlots);
    }
    get filterPreset() {
        return this.story.filterPreset;
    }
    get timelineIds() {
        return (0, sortKeys_1.sortKeys)(Object.keys(this.story.timelines));
    }
    get lastTimelineId() {
        return this.timelineIds[this.timelineIds.length - 1];
    }
    get timeline() {
        return this.story.timelines[this.timelineId];
    }
    get step() {
        return this._steps[this.stepId];
        // return this.timeline.steps[this.stepId];
    }
    // @TODO: Ideally dont expose this
    get steps() {
        return this._steps;
    }
    get firstStep() {
        return this.timeline.steps.s1;
    }
    // @TODO: Ideally dont expose this
    get stepIds() {
        return (0, sortKeys_1.sortKeys)(Object.keys(this.steps));
    }
    get lastStepId() {
        return this.stepIds[this.stepIds.length - 1];
    }
    get charIds() {
        return this.slotIds.map((id) => this.getSlot(id).charMetadata.id);
    }
    get selectedChoice() {
        return this._selectedChoice;
    }
    get revealedTimeline() {
        return this.story.revealedTimelineId;
    }
    get query() {
        return {
            isSlotEnabled: (id) => {
                if (!this.slots[id]) {
                    throw new Error(`Error (isSlotEnabled): Could not find slot with id '${id}'.`);
                }
                return !this.slots[id].disabledOnStart;
            },
            isTalking: (id) => {
                var _a;
                if (!this.slots[id]) {
                    throw new Error(`Error (isTalking): Could not find slot with id '${id}'.`);
                }
                return ((_a = this.step.bubble) === null || _a === void 0 ? void 0 : _a.charSlotId) === id;
            },
            charDir: (id) => {
                var _a;
                if (!this.slots[id]) {
                    throw new Error(`Error (charDir): Could not find slot with id '${id}'.`);
                }
                return (((_a = this.step.getGesture(id)) === null || _a === void 0 ? void 0 : _a.dirX) ||
                    this.slots[id].layout.dir);
            },
        };
    }
    /*
      We need to emit off the events once the listeners are set
      force setting step since this is so the games reads initial state
      because we set storyTeller data prior to loading the game part
    */
    init() {
        this.storyEventHandler(StoryEvents.FILTER_UPDATE);
        this.storyEventHandler(StoryEvents.TIMELINE_NAVIGATION);
        this.storyEventHandler(StoryEvents.STEP_NAVIGATION);
        this.storyEventHandler(StoryEvents.SLOTS_UPDATE);
        this.stepEventHandler(StepEvents.BUBBLE_UPDATE, this.step, true);
        this.stepEventHandler(StepEvents.GESTURES_UPDATE, this.step, true);
        this.stepEventHandler(StepEvents.CAMERA_UPDATE, this.step, true);
        this.stepEventHandler(StepEvents.BACKGROUND_UPDATE, this.step, true);
        this.stepEventHandler(StepEvents.CHOICES_UPDATE, this.step, true);
    }
    setEventListener(fn) {
        this._onStoryUpdate = fn;
    }
    getChar(id) {
        return this.slots[id];
    }
    goToCliffhanger() {
        if (!this.revealedTimeline) {
            console.error(`Error (goToCliffhanger): No 'revealedTimeline' set.`);
            return this;
        }
        // Go to the last revealed timeline
        this.goToTimeline(this.revealedTimeline);
        // then go to the last step
        this.goToStep(this.lastStep);
        return this;
    }
    goToNextStep() {
        if (!this.step.nextStep) {
            if (this.timeline.mergeTimeline) {
                this.goToTimeline(this.timeline.mergeTimeline);
                return this;
            }
            console.error(`Error (goToNextStep): Trying to go to next step from last step. Skipping...`);
            return this;
        }
        this.goToStep(this.step.nextStep);
        return this;
    }
    goToPrevStep() {
        if (!this.step.prevStep) {
            console.error(`Error (goToPrevStep): Trying to go to previous step from first step. Skipping...`);
            return this;
        }
        this.goToStep(this.step.prevStep);
        return this;
    }
    goToStep(id) {
        if (!this.steps[id]) {
            throw new Error(`Error (goToStep): Step with id '${id}' does not exist.`);
        }
        this.stepId = id;
        this.storyEventHandler(StoryEvents.STEP_NAVIGATION);
        return this;
    }
    goToStepByIndex(index) {
        if (!this.stepIds[index]) {
            throw new Error(`Error (goToStepByIndex): Not a valid index '${index}'. (Steps length: ${this.stepsCount}).`);
        }
        this.stepId = this.stepIds[index];
        this.storyEventHandler(StoryEvents.STEP_NAVIGATION);
        return this;
    }
    selectChoice(id) {
        var _a;
        const choice = (_a = this.step.choices) === null || _a === void 0 ? void 0 : _a[id];
        if (!choice) {
            throw new Error(`Error (selectChoice): Cannot find choice with id '${id}'.`);
        }
        this.story.choicesMade[this._timelineId] = id;
        this.goToTimeline(choice.toTimeline, choice);
    }
    goToMergeTimeline() {
        if (!this.timeline.toTimeline) {
            console.error(`Error (goToMergeTimeline): Current timeline doenst have a 'toTimeline'. Skipping...`);
            return this;
        }
        this.goToTimeline(this.timeline.toTimeline);
        return this;
    }
    goToTimeline(id, choice) {
        if (!this.story.timelines[id]) {
            console.error(`Error (gotToTimeline): Could not find timeline with id '${id}'. Skipping...`);
            return this;
        }
        // Reset step marker before moving timelines to prevent undefined step
        this.stepId = exports.INITIAL_STEP;
        this._selectedChoice = choice;
        this._timelineId = id;
        this.updateSteps();
        this.storyEventHandler(StoryEvents.TIMELINE_NAVIGATION);
        return this;
    }
    goToPrevChoiceTimeline() {
        if (!this.isMergeTimeline) {
            console.error(`Error (goToPrevChoiceTimeline): Can only be callen from a merge timeline. Skipping...`);
            return this;
        }
        const choiceId = this.story.choicesMade[this.timeline.root];
        this.goToTimeline(this.timeline.root);
        this.goToStep(this.timeline.lastStep);
        this.selectChoice(choiceId);
        this.goToStep(this.timeline.lastStep);
        return this;
    }
    goToPrevTimeline() {
        if (this.timelineId === exports.INITIAL_TIMELINE) {
            console.error(`Error (goToPrevTimeline): Cannot go up from root timeline. Skipping...`);
            return this;
        }
        this.goToTimeline(this.timeline.root);
        this.goToStep(this.lastStepId);
        return this;
    }
    disableSlot(id) {
        if (!this.story.charSlots[id]) {
            console.error(`Error (disableSlot): Cannot find slot with id '${id}'. Skipping...`);
            return this;
        }
        const prevCharSlots = (0, copy_1.copy)(this.story.charSlots);
        this.story.charSlots[id].disabledOnStart = true;
        this.storyEventHandler(StoryEvents.SLOTS_UPDATE, getDiff(prevCharSlots, this.story.charSlots));
        return this;
    }
    enableSlot(id) {
        if (!this.story.charSlots[id]) {
            console.error(`Error (enableSlot): Cannot find slot with id '${id}'. Skipping...`);
            return this;
        }
        const prevCharSlots = (0, copy_1.copy)(this.story.charSlots);
        this.story.charSlots[id].disabledOnStart = false;
        this.storyEventHandler(StoryEvents.SLOTS_UPDATE, getDiff(prevCharSlots, this.story.charSlots));
        return this;
    }
    getSlot(id) {
        const slot = this.story.charSlots[id];
        if (!slot) {
            throw new Error(`Error (slot): Cannot find slot with id '${id}'.`);
        }
        return (0, copy_1.copyStrict)(slot);
    }
    updateSlotName(id, name) {
        if (!this.story.charSlots[id]) {
            throw new Error(`Error (slot): Cannot find slot with id '${id}'.`);
        }
        const prevCharSlots = (0, copy_1.copy)(this.story.charSlots);
        this.story.charSlots[id].displayName = name;
        this.storyEventHandler(StoryEvents.SLOTS_UPDATE, getDiff(prevCharSlots, this.story.charSlots));
        return this;
    }
    setFilter(filter) {
        this.story.filterPreset = filter;
        this.storyEventHandler(StoryEvents.FILTER_UPDATE);
        return this;
    }
    setVersion(version) {
        if (version > migration_1.lastMigrationVersion) {
            console.error(`Error: Cannot set version '${version}' higher than last migration version '${migration_1.lastMigrationVersion}'. Skipping...`);
            return this;
        }
        if (version < storyConfig.firstMigrationVersion) {
            console.error(`Error: Cannot set version '${version}' lower than first migration version '${storyConfig.firstMigrationVersion}'. Skipping...`);
            return this;
        }
        this.story.metadata.version = version;
        return this;
    }
    save(editedBy) {
        this.story.metadata.timestamp = Date.now();
        this.story.metadata.saveCount += 1;
        this.story.metadata.editedBy = editedBy;
        return this;
    }
    addSlot(charMetadata) {
        if (this.slotIds.length === storyConfig.maxChars) {
            console.error(`Error: Cannot add more than ${storyConfig.maxChars} characters. Skipping...`);
            return this;
        }
        const prevCharSlots = (0, copy_1.copy)(this.story.charSlots);
        const nextId = `cs${this.slotIds.length + 1}`;
        const config = getSlotDefaultConfig(nextId);
        this.story.charSlots[nextId] = {
            ...config,
            displayName: undefined,
            charMetadata,
            overrideable: undefined,
        };
        this.storyEventHandler(StoryEvents.SLOTS_UPDATE, getDiff(prevCharSlots, this.story.charSlots));
        return this;
    }
    updateChar(id, charMetadata) {
        if (!this.story.charSlots[id]) {
            throw new Error(`Error (updateChar): Could not find slot with id '${id}'.`);
        }
        const prevCharSlots = (0, copy_1.copy)(this.story.charSlots);
        this.story.charSlots[id].charMetadata = charMetadata;
        this.storyEventHandler(StoryEvents.SLOTS_UPDATE, getDiff(prevCharSlots, this.story.charSlots));
        return this;
    }
    // @TODO: Not sure if this should belong here
    // addCharacterFromMetadata(metadataUrl: string): Promise<StoryTeller> {}
    onAddChoiceOption() {
        // Create choice timeline
        const choiceTimelineId = this.addTimeline();
        // Add copy of current step as first step in new timeline
        const stepCopy = this.step.getCopy();
        stepCopy.nextStep = undefined;
        stepCopy.prevStep = undefined;
        stepCopy.choices = undefined;
        stepCopy.camera = StepClass.getCamera({
            ...stepCopy.camera,
            motions: undefined,
        });
        this.story.timelines[choiceTimelineId].steps.s1 = stepCopy;
        // Set choice timeline toTimeline to merge timeline
        this.story.timelines[choiceTimelineId].toTimeline =
            this.story.timelines[this.timelineId].mergeTimeline;
        if (this.step.choiceIds.length !== 0) {
            return choiceTimelineId;
        }
        // Create merge timeline
        const mergeTimeline = this.addTimeline();
        this.story.timelines[mergeTimeline].steps.s1 = stepCopy;
        // Set mergeTimeline in our timeline's root timeline
        this.timeline.mergeTimeline = mergeTimeline;
        // Set choice timeline toTimeline to merge timeline
        this.story.timelines[choiceTimelineId].toTimeline = mergeTimeline;
        // Remove all steps after current
        const stepsToRemove = [];
        // From the last step to the first until we find ours, dispose anything before us
        for (let i = this.stepIds.length - 1; i > 0; i--) {
            const id = this.stepIds[i];
            if (id === this.stepId) {
                break;
            }
            stepsToRemove.push(id);
        }
        stepsToRemove.forEach((id) => this.removeStepById(id));
        return choiceTimelineId;
    }
    onRemoveChoiceOption(id) {
        if (!this.step.choices) {
            console.error(`Error (removeChoice): Step does not have choices. Skipping...`);
            return this;
        }
        if (!this.step.choices[id]) {
            console.error(`Error (removeChoice): Could not find choice for id '${id}'. Skipping...`);
            return this;
        }
        // If we are removing the last choice left, then remove the merge timeline as well
        if (this.step.choiceIds.length === 1) {
            const choiceTimeline = this.story.timelines[this.step.choices[id].toTimeline];
            if (choiceTimeline.toTimeline) {
                this.removeTimeline(choiceTimeline.toTimeline);
                this.timeline.mergeTimeline = undefined;
            }
            else {
                console.error(`Error (removeChoice): Something unexpected happened. We always expect choiceTimline to have toTimeline. Investigate`);
                return this;
            }
        }
        this.removeTimeline(this.step.choices[id].toTimeline);
        return this;
    }
    removeTimeline(id) {
        var _a;
        if (id === exports.INITIAL_TIMELINE) {
            console.error(`Error (removeTimeline): Cannot remove root timeline. Skipping...`);
            return this;
        }
        const timeline = this.story.timelines[id];
        if (!timeline) {
            console.error(`Error (removeTimeline): Could not find timeline with id '${id}'. Skipping...`);
            return this;
        }
        if (this.timeline === timeline) {
            console.error(`Error (removeTimeline): Cannot remove currently selected timeline. Skipping...`);
            return this;
        }
        const choices = (_a = Object.values(timeline.steps).find((s) => s.choices)) === null || _a === void 0 ? void 0 : _a.choices;
        if (choices) {
            Object.values(choices).forEach((c) => this.removeTimeline(c.toTimeline));
        }
        const hasLinks = Object.values(this.story.timelines).some(t => t !== timeline && t.toTimeline === timeline.toTimeline);
        if (timeline.toTimeline && !hasLinks) {
            this.removeTimeline(timeline.toTimeline);
        }
        delete this.story.timelines[id];
        return this;
    }
    addStep() {
        // This should ONLY happen when creating a story from scratch
        if (!this.step) {
            const step = this.getStep(this.stepId, {
                prevStep: undefined,
                nextStep: undefined,
                parallax: undefined,
                camera: undefined,
                bubble: undefined,
                choices: undefined,
                gestures: {},
            });
            this._steps[this.stepId] = step;
            this.timeline.steps[this.stepId] = step.getCopy();
            return this;
        }
        return this.addStepAfter(this.stepId);
    }
    addStepAfter(stepId) {
        // This can ONLY happen on a new story if it's called before 'addStep'
        if (!this.firstStep) {
            throw new Error(`Error (addStepAfter): Could not find firstStep`);
        }
        if (this.steps[stepId].choices) {
            console.error(`Error (addStepAfter): Cannot add step after step with choices. Skipping...`);
            return this;
        }
        let isBefore = true;
        const newSteps = {};
        this.stepIds.forEach((id) => {
            const step = this.steps[id];
            if (isBefore) {
                newSteps[id] = step;
            }
            else {
                const newId = (0, sortKeys_1.increaseId)(id);
                newSteps[newId] = this.getStep(newId, {
                    ...step.getCopy(),
                    prevStep: id,
                    nextStep: this.lastStepId === id ? undefined : (0, sortKeys_1.increaseId)(newId),
                });
            }
            // Insert the new step as copy of the current
            if (id === stepId) {
                isBefore = false;
                const newId = (0, sortKeys_1.increaseId)(id);
                newSteps[id] = this.getStep(id, {
                    ...newSteps[id].getCopy(),
                    nextStep: newId,
                });
                // Inserting Step
                newSteps[newId] = this.getStep(newId, {
                    ...step.getCopy(),
                    prevStep: id,
                    nextStep: this.lastStepId === id ? undefined : (0, sortKeys_1.increaseId)(newId),
                });
            }
        });
        this.setSteps(newSteps);
        this.timeline.lastStep = this.lastStepId;
        return this;
    }
    removeStep() {
        console.info(`Info (removeStep): Removing step '${this.stepId}'`);
        return this.removeStepById(this.stepId);
    }
    removeStepById(stepId) {
        if (this.stepIds.length === 1) {
            console.error(`Error (removeStepById): Cannot remove all steps. Skipping...`);
            return this;
        }
        if (!this.steps[stepId]) {
            console.error(`Error (removeStepById): Step id '${stepId}' not found in steps. Skipping...`);
            return this;
        }
        // If we are deleting a step with choices we need to delete all timelines related to it
        const choices = this.steps[stepId].choices;
        if (choices) {
            Object.values(choices).forEach((c) => {
                this.removeTimeline(c.toTimeline);
            });
        }
        const newSteps = {};
        let isBefore = true;
        this.stepIds.forEach((id) => {
            const step = this.steps[id];
            if (id === stepId) {
                isBefore = false;
                if (id === this.lastStepId) {
                    const newId = (0, sortKeys_1.decreaseId)(id);
                    newSteps[newId] = this.getStep(newId, {
                        ...newSteps[(0, sortKeys_1.decreaseId)(id)].getCopy(),
                        nextStep: undefined,
                    });
                }
                return;
            }
            if (isBefore) {
                newSteps[id] = step;
            }
            else {
                const newId = (0, sortKeys_1.decreaseId)(id);
                newSteps[newId] = this.getStep(newId, {
                    ...step.getCopy(),
                    prevStep: newId === exports.INITIAL_STEP ? undefined : (0, sortKeys_1.decreaseId)(newId),
                    nextStep: id === this.lastStepId ? undefined : id,
                });
            }
        });
        const index = this.linearStepIndex - (this.step.id === this.lastStep ? 1 : 0);
        this.setSteps(newSteps);
        this.timeline.lastStep = this.lastStepId;
        this.stepId = this.stepIds[index];
        this.storyEventHandler(StoryEvents.STEP_NAVIGATION);
        return this;
    }
    onStepUpdate(step) {
        this._steps[step.id] = step;
        this.timeline.steps[step.id] = step.getCopy();
    }
    setSteps(steps) {
        this._steps = steps;
        this.timeline.steps = this.stepIds.reduce((res, cur) => ({
            ...res,
            [cur]: steps[cur].getCopy(),
        }), {});
    }
    addTimeline() {
        const id = (0, sortKeys_1.increaseId)(this.lastTimelineId);
        // If timeline already exists then something is wrong (maybe with our assumptions)
        if (this.story.timelines[id]) {
            throw new Error(`Error (addTimeline): Timeline already exists for id '${id}'.`);
        }
        // @TODO: We might want to have a default step
        this.story.timelines[id] = {
            root: this.timelineId,
            firstStep: exports.INITIAL_STEP,
            lastStep: exports.INITIAL_STEP,
            steps: {},
            toTimeline: undefined,
            mergeTimeline: undefined,
        };
        return id;
    }
    getStep(stepId, step) {
        return new StepClass(stepId, {
            prevStep: step.prevStep,
            nextStep: step.nextStep,
            parallax: step.parallax,
            camera: step.camera,
            bubble: step.bubble,
            choices: step.choices,
            gestures: step.gestures || {},
        }, {
            handleAddChoiceOption: () => this.onAddChoiceOption(),
            handleRemoveChoiceOption: (id) => {
                this.onRemoveChoiceOption(id);
            },
            onUpdate: (evt, step) => {
                this.stepEventHandler(evt, step);
            },
        });
    }
    addEventHandler(evt, fn) {
        if (!this.eventHandlers[evt]) {
            this.eventHandlers[evt] = [];
        }
        const id = Date.now();
        this.eventHandlers[evt].push({ id, fn });
        return {
            detach: () => {
                this.eventHandlers[evt] = this.eventHandlers[evt].filter((ev) => ev.id !== id);
            },
        };
    }
    // Events
    onBubbleUpdate(fn) {
        return this.addEventHandler(StepEvents.BUBBLE_UPDATE, fn);
    }
    onGesturesUpdate(fn) {
        return this.addEventHandler(StepEvents.GESTURES_UPDATE, fn);
    }
    onCameraUpdate(fn) {
        return this.addEventHandler(StepEvents.CAMERA_UPDATE, fn);
    }
    onBackgroundUpdate(fn) {
        return this.addEventHandler(StepEvents.BACKGROUND_UPDATE, fn);
    }
    onChoicesUpdate(fn) {
        return this.addEventHandler(StepEvents.CHOICES_UPDATE, fn);
    }
    onSlotsChange(fn) {
        return this.addEventHandler(StoryEvents.SLOTS_UPDATE, fn);
    }
    onFilterChange(fn) {
        return this.addEventHandler(StoryEvents.FILTER_UPDATE, fn);
    }
    onTimelineChange(fn) {
        return this.addEventHandler(StoryEvents.TIMELINE_NAVIGATION, fn);
    }
    onStepChange(fn) {
        return this.addEventHandler(StoryEvents.STEP_NAVIGATION, fn);
    }
    onStoryUpdate() {
        this._onStoryUpdate && this._onStoryUpdate(this.write());
    }
    stepEventHandler(evt, step, force = false) {
        const prevStep = this.step.pre;
        // update story data
        this.onStepUpdate(step);
        const newStep = this.step.getCopy();
        const handlers = this.eventHandlers[evt] || [];
        // Fire off event to listeners
        handlers.forEach((handler) => {
            const v1 = prevStep[evt];
            const v2 = newStep[evt];
            const diff = getDiff(v1, v2);
            if (force || diff.diff) {
                handler.fn(diff);
            }
        });
        this.onStoryUpdate();
    }
    storyEventHandler(evt, diff) {
        const handlers = this.eventHandlers[evt] || [];
        // Fire off event to listeners
        handlers.forEach((handler) => {
            handler.fn(diff);
        });
        if (evt === StoryEvents.STEP_NAVIGATION) {
            this.stepEventHandler(StepEvents.BUBBLE_UPDATE, this.step, true);
            this.stepEventHandler(StepEvents.GESTURES_UPDATE, this.step, true);
            this.stepEventHandler(StepEvents.CAMERA_UPDATE, this.step, true);
            this.stepEventHandler(StepEvents.BACKGROUND_UPDATE, this.step, true);
            this.stepEventHandler(StepEvents.CHOICES_UPDATE, this.step, true);
        }
        this.onStoryUpdate();
    }
    updateSteps() {
        this._steps = (0, sortKeys_1.sortKeys)(Object.keys(this.timeline.steps)).reduce((res, cur) => {
            return {
                ...res,
                [cur]: this.getStep(cur, this.timeline.steps[cur]),
            };
        }, {});
        this.storyEventHandler(StoryEvents.STEP_NAVIGATION);
    }
    // IO
    read(story, props) {
        this.story = story;
        // Should we assume read is a new story the teller reads therefore should set initial values again
        this._timelineId = (props === null || props === void 0 ? void 0 : props.timelineId) || exports.INITIAL_TIMELINE;
        this.stepId = (props === null || props === void 0 ? void 0 : props.stepId) || exports.INITIAL_STEP;
        this._selectedChoice = undefined;
        this.updateSteps();
        return this;
    }
    write() {
        return this.story;
    }
    // Should be used ONLY for testing purposes
    __DANGEROUSLY_SET_METADATA(metadata) {
        console.warn(`This method should be STRICTLY used for testing purposes. Do not use it in runtime`);
        this.story.metadata = metadata;
        return this;
    }
}
exports.StoryTeller = StoryTeller;
// Map to the key from IStep
var StepEvents;
(function (StepEvents) {
    StepEvents["BUBBLE_UPDATE"] = "bubble";
    StepEvents["CAMERA_UPDATE"] = "camera";
    StepEvents["BACKGROUND_UPDATE"] = "parallax";
    StepEvents["GESTURES_UPDATE"] = "gestures";
    StepEvents["CHOICES_UPDATE"] = "choices";
})(StepEvents = exports.StepEvents || (exports.StepEvents = {}));
class StepClass {
    constructor(_id, step, props) {
        this._id = _id;
        this.step = step;
        this.props = props;
        this.prevState = step;
    }
    get id() {
        return this._id;
    }
    get prevStep() {
        return this.step.prevStep;
    }
    get nextStep() {
        return this.step.nextStep;
    }
    get choices() {
        return this.step.choices ? (0, copy_1.copy)(this.step.choices) : undefined;
    }
    get choiceIds() {
        if (!this.step.choices) {
            return [];
        }
        return (0, sortKeys_1.sortKeys)(Object.keys(this.step.choices));
    }
    get bgImage() {
        var _a, _b;
        return (_b = (_a = this.step.parallax) === null || _a === void 0 ? void 0 : _a.layers[0]) === null || _b === void 0 ? void 0 : _b.image;
    }
    get activeCharId() {
        var _a, _b;
        return ((_a = this.step.bubble) === null || _a === void 0 ? void 0 : _a.charSlotId) || ((_b = this.step.camera) === null || _b === void 0 ? void 0 : _b.charSlotId);
    }
    get bubble() {
        return (0, copy_1.copy)(this.step.bubble);
    }
    get camera() {
        return (0, copy_1.copy)(this.step.camera);
    }
    get parallax() {
        return (0, copy_1.copy)(this.step.parallax);
    }
    // @TODO: Ideally this shouldn't be exposed
    get gestures() {
        return (0, copy_1.copyStrict)(this.step.gestures || {});
    }
    get pre() {
        return this.prevState;
    }
    clone() {
        return new StepClass(this._id, this.step, this.props);
    }
    getCopy() {
        return (0, copy_1.copyStrict)(this.step);
    }
    getGesture(id) {
        if (!this.step.gestures[id]) {
            throw new Error(`Error (getGesture): Could not find gesture for id '${id}'.`);
        }
        return (0, copy_1.copy)(this.step.gestures[id]);
    }
    updateCamera(cam) {
        this.prevState = this.getCopy();
        this.step.camera =
            cam &&
                StepClass.getCamera({
                    ...this.camera,
                    ...cam,
                });
        return this.updateCallback(StepEvents.CAMERA_UPDATE);
    }
    updateBackground(bg) {
        this.prevState = this.getCopy();
        this.step.parallax =
            bg &&
                StepClass.getBackground({
                    ...this.step.parallax,
                    ...bg,
                });
        return this.updateCallback(StepEvents.BACKGROUND_UPDATE);
    }
    updateBackgroundImage(image) {
        if (!this.step.parallax) {
            throw new Error(`Error (updateBackgroundImage): Trying to update image without parallax set.`);
        }
        this.prevState = this.getCopy();
        const newBg = StepClass.getBackground(this.step.parallax, image);
        this.step.parallax = newBg;
        return this.updateCallback(StepEvents.BACKGROUND_UPDATE);
    }
    updateBubble(bubble) {
        this.prevState = this.getCopy();
        if (!bubble) {
            this.step.bubble = undefined;
            return this.updateCallback(StepEvents.BUBBLE_UPDATE);
        }
        // If we are setting bubble
        if (!this.bubble) {
            if (!bubble.caption || !bubble.layout) {
                throw new Error(`Error (updateBubble): Cannot set bubble without 'caption' or 'layout'.`);
            }
        }
        this.step.bubble = StepClass.getBubble({
            ...this.bubble,
            ...bubble,
        });
        return this.updateCallback(StepEvents.BUBBLE_UPDATE);
    }
    updateGesture(id, gesture) {
        this.prevState = this.getCopy();
        if (!gesture.charSlotId) {
            throw new Error(`Error (updateGesture): Trying to update charSlotId '${id}' without 'charSlotId' in gesture.`);
        }
        if (id !== gesture.charSlotId) {
            throw new Error(`Error (updateGesture): Trying to update charSlotId '${id}' with gesture using different id (${gesture.charSlotId}).`);
        }
        const currentGesture = this.step.gestures[id];
        this.step.gestures = {
            ...this.step.gestures,
            [id]: StepClass.getGesture({
                ...currentGesture,
                ...gesture,
            }),
        };
        return this.updateCallback(StepEvents.GESTURES_UPDATE);
    }
    updateChoice(id, caption) {
        this.prevState = this.getCopy();
        if (!this.step.choices) {
            console.error(`Error (updateChocice): Current step does not have choices. Did you forget to add choice?`);
            return this;
        }
        if (!this.step.choices[id]) {
            console.error(`Error (updateChocice): Could not find choice for id '${id}'. Did you forget to add choice?`);
            return this;
        }
        this.step.choices[id].caption = caption;
        return this.updateCallback(StepEvents.CHOICES_UPDATE);
    }
    addChoice() {
        this.prevState = this.getCopy();
        if (this.choiceIds.length === storyConfig.maxChoiceOptions) {
            console.error(`Error (addChoice): Choice limit (${storyConfig.maxChars}) reached. Skipping...`);
            return this;
        }
        const toTimeline = this.props.handleAddChoiceOption();
        const index = this.choiceIds.length + 1;
        const newId = `c${index}`;
        const caption = `Option ${index}`;
        if (!this.step.choices) {
            this.step.choices = {};
        }
        this.step.choices[newId] = {
            caption,
            toTimeline,
        };
        return this.updateCallback(StepEvents.CHOICES_UPDATE);
    }
    removeChoice(id) {
        this.prevState = this.getCopy();
        if (!this.step.choices) {
            console.error(`Error (removeChoice): Step does not have choices. Skipping...`);
            return this;
        }
        if (!this.step.choices[id]) {
            console.error(`Error (removeChoice): Could not find choice for id '${id}'. Skipping...`);
            return this;
        }
        this.props.handleRemoveChoiceOption(id);
        delete this.step.choices[id];
        if (this.choiceIds.length === 0) {
            this.step.choices = undefined;
        }
        return this.updateCallback(StepEvents.CHOICES_UPDATE);
    }
    static getCamera(cam) {
        return {
            charSlotId: cam.charSlotId,
            preset: cam.preset,
            motions: cam.motions,
        };
    }
    static getBackgroundLayer(layer) {
        return {
            image: layer.image,
            width: layer.width,
            height: layer.height,
            x: layer.x,
            y: layer.y,
        };
    }
    static getBackground(bg, image) {
        const layers = image
            ? (bg.layers || []).map((layer) => {
                return StepClass.getBackgroundLayer({ ...layer, image });
            })
            : bg.layers || [];
        return {
            width: bg.width || 1500,
            height: bg.height || 1500,
            y: bg.y || 0,
            layers,
        };
    }
    static getBubble(bubble) {
        return {
            mode: bubble.mode,
            tagname: bubble.tagname,
            tagcolor: bubble.tagcolor,
            charSlotId: bubble.charSlotId,
            layout: bubble.layout,
            caption: bubble.caption,
        };
    }
    static getGesture(gesture) {
        return {
            charSlotId: gesture.charSlotId,
            dirX: gesture.dirX,
            animation: gesture.animation,
            loop: gesture.loop,
            charPos: gesture.charPos,
            charMotion: gesture.charMotion,
            visible: gesture.visible,
        };
    }
    updateCallback(evt) {
        this.props.onUpdate(evt, this);
        return this;
    }
}
/**
 * This is so we can export the type of Step without exporting the class
 * It won't work if try to use 'typeof Step', it must type of an instance of step
 */
const instance = new StoryTeller().addStep().step;
//# sourceMappingURL=StoryTeller.js.map